export type HostOs = "macos" | "windows" | "linux" | "web" | "unknown";

export type RendererHostCapabilities = {
  nativeFilePicker: boolean;
  desktopUpdates: boolean;
  nativeFullscreen: boolean;
  localPathOpen: boolean;
  macAutomation: boolean;
  imessage: boolean;
  appleEvents: boolean;
  tccPrivacyPrompts: boolean;
  revealInFolderLabel: "Show in Finder" | "Show in Explorer" | "Show in Folder";
  primaryShortcutModifier: "Cmd" | "Ctrl";
};

export function normalizeHostOs(value?: string | null): HostOs {
  const normalized = value?.trim().toLowerCase() ?? "";
  if (!normalized) {
    return "unknown";
  }
  if (normalized === "darwin" || normalized.includes("mac")) {
    return "macos";
  }
  if (normalized === "win32" || normalized.includes("win")) {
    return "windows";
  }
  if (normalized === "linux") {
    return "linux";
  }
  if (normalized === "web" || normalized === "cloud") {
    return "web";
  }
  return "unknown";
}

export function buildElectronHostCapabilities(os: HostOs): RendererHostCapabilities {
  const isMac = os === "macos";
  const isWindows = os === "windows";

  return {
    nativeFilePicker: true,
    desktopUpdates: true,
    nativeFullscreen: isMac,
    localPathOpen: true,
    macAutomation: isMac,
    imessage: isMac,
    appleEvents: isMac,
    tccPrivacyPrompts: isMac,
    revealInFolderLabel: isMac ? "Show in Finder" : isWindows ? "Show in Explorer" : "Show in Folder",
    primaryShortcutModifier: isMac ? "Cmd" : "Ctrl",
  };
}

export const CLOUD_HOST_CAPABILITIES: RendererHostCapabilities = {
  nativeFilePicker: false,
  desktopUpdates: false,
  nativeFullscreen: false,
  localPathOpen: false,
  macAutomation: false,
  imessage: false,
  appleEvents: false,
  tccPrivacyPrompts: false,
  revealInFolderLabel: "Show in Folder",
  primaryShortcutModifier: "Ctrl",
};
